import { InputForm, SubmitButton, Error, Textarea } from "components";
import {
  CreateDcddMembershipPlanInput,
  CreateDcddMembershipPlanInputError,
} from "../../store/actionType";
interface FormProps {
  handleSave: (event: React.FormEvent<HTMLButtonElement>) => void;
  formData: CreateDcddMembershipPlanInput;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error: CreateDcddMembershipPlanInputError;
  loading: boolean;
  header: string;
}
const DcddMembershiPlanForm: React.FC<FormProps> = ({
  formData,
  handleChange,
  error,
  loading,
  handleSave,
  header,
}) => {
  return (
    <section className="w-full flex flex-col items-center justify-center p-4">
      <form className="w-full max-w-screen-md">
        <h2 className="text-2xl font-bold text-center mb-4">{header}</h2>
        <div className="grid grid-cols-1 gap-3">
          <div>
            <InputForm
              label="DCDD Memebership Plan"
              type="text"
              id="membership_plan"
              name="membership_plan"
              value={formData.membership_plan}
              onChange={handleChange}
            />
            {error.membership_plan && <Error>{error.membership_plan}</Error>}
          </div>
          <div>
            <InputForm
              label="End Date"
              type="datetime-local"
              id="end_date"
              name="end_date"
              value={formData.end_date}
              onChange={handleChange}
            />
            {error.end_date && <Error>{error.end_date}</Error>}
          </div>
          <div>
            <InputForm
              label="User Limit"
              type="number"
              id="user_limit"
              name="user_limit"
              value={formData.user_limit}
              onChange={handleChange}
            />
            {error.user_limit && <Error>{error.user_limit}</Error>}
          </div>
          <div>
            <InputForm
              label="Remarks"
              type="text"
              id="remarks"
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
            />
            {error.remarks && <Error>{error.remarks}</Error>}
          </div>
        </div>
        <div className="flex items-center justify-between mt-6">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </section>
  );
};
export default DcddMembershiPlanForm;
